import { render, staticRenderFns } from "./DuplicatePostSelection.vue?vue&type=template&id=8a6260c0&scoped=true&"
import script from "./DuplicatePostSelection.vue?vue&type=script&lang=js&"
export * from "./DuplicatePostSelection.vue?vue&type=script&lang=js&"
import style0 from "./DuplicatePostSelection.vue?vue&type=style&index=0&id=8a6260c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6260c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a6260c0')) {
      api.createRecord('8a6260c0', component.options)
    } else {
      api.reload('8a6260c0', component.options)
    }
    module.hot.accept("./DuplicatePostSelection.vue?vue&type=template&id=8a6260c0&scoped=true&", function () {
      api.rerender('8a6260c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/duplication/DuplicatePostSelection.vue"
export default component.exports